import { render, staticRenderFns } from "./CareersPage.vue?vue&type=template&id=52e90348&scoped=true&"
import script from "./CareersPage.vue?vue&type=script&lang=js&"
export * from "./CareersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e90348",
  null
  
)

export default component.exports